export default __webpack_public_path__ + "static/media/20.6cc790d0.png";